import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgArrowUpCircleFilled = (props, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 34,
	height: 34,
	viewBox: "0 0 34 34",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: [/* @__PURE__ */ _jsx("g", {
		clipPath: "url(#clip0_4851_1003)",
		children: /* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M0 17C-4.10398e-07 7.61116 7.61116 4.10399e-07 17 0C26.3888 -4.10399e-07 34 7.61116 34 17C34 26.3888 26.3888 34 17 34C7.61116 34 4.104e-07 26.3888 0 17ZM10.293 16.293C9.90244 16.6835 9.90244 17.3165 10.293 17.707C10.6835 18.0976 11.3165 18.0976 11.707 17.707L16 13.4141V23C16 23.5523 16.4477 24 17 24C17.5523 24 18 23.5523 18 23V13.4141L22.293 17.707C22.6835 18.0976 23.3165 18.0976 23.707 17.707C24.0976 17.3165 24.0976 16.6835 23.707 16.293L17.707 10.293C17.3165 9.90244 16.6835 9.90244 16.293 10.293L10.293 16.293Z",
			fill: "currentColor"
		})
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_4851_1003",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 34,
			height: 34,
			fill: "white"
		})
	}) })]
});
const ForwardRef = forwardRef(SvgArrowUpCircleFilled);
export { ForwardRef as ReactComponent };
